import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import { FaPhoneAlt, FaFacebookF, FaInstagram, FaBars } from 'react-icons/fa';
import { API_BASE_URL } from '../config';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [contacts, setContacts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch contact numbers from backend
    fetch(`${API_BASE_URL}/contacts`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setContacts(data);
        }
      })
      .catch(err => console.error('Error fetching contacts:', err));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/'); // redirect to home after logout
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="top-bar">
        <div className="contact-left">
          <FaPhoneAlt className="icon" />
          <div className="contact-numbers">
            {contacts.length > 0 ? (
              contacts.map(c => (
                  <li key={c.id}>{c.phone}</li>
                ))

            ) : (
              <div></div>
            )}
          </div>
        </div>
        <div className="social-right">
          <a href="https://www.facebook.com/sptechrao" target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="icon" />
          </a>
          <a href="https://www.linkedin.com/in/sptech-rao-12ab11a5/" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="icon" />
          </a>
        </div>
      </div>

      {/* Logo and Navigation */}
      <header className="header">
        <div className="logo-section">
          <img src={logo} alt="Institute Logo" className="logo-img" />
          <p className="tagline">The Leader in SAP-ABAP Since-2007</p>
        </div>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </button>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/">Home</Link>
          <Link to="/courses">Courses</Link>
          <Link to="/students">Students</Link>
          <Link to="/contactus">Contact Us</Link>
          <Link to="/reviews">Reviews</Link>

          {/* Login/Logout */}
          {isLoggedIn ? (
            <button className="login-btn" onClick={handleLogout}>Logout</button>
          ) : (
            <Link to="/login" className="login-btn">Login</Link>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;